var React = require('react');

function External (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 11.8357L1.6643 13.5L10.6378 4.52649L10.618 9.77113L12.9667 9.76258L13 0.5L3.73746 0.533289L3.72885 2.882L8.97347 2.86219L0 11.8357Z","fill":"currentColor"}));
}

External.defaultProps = {"width":"13","height":"14","viewBox":"0 0 13 14","fill":"none"};

module.exports = External;

External.default = External;
